import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2014')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('installation') || media.includes('sculpture');
  })
  .slice(0, 4);

export default function OlgaLah() {
  const slides = [
    { src: '/uploads/2016/11/olga_lah_Convergence-2015.jpg', alt: 'Olga Lah work 1' },
    { src: '/uploads/2016/11/olga1.jpg', alt: 'Olga Lah work 2' },
    { src: '/uploads/2016/11/olga2.jpg', alt: 'Olga Lah work 3' },
    { src: '/uploads/2016/11/olga3.jpg', alt: 'Olga Lah work 4' },
    { src: '/uploads/2016/11/olga4.jpg', alt: 'Olga Lah work 5' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Olga Lah</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Olga Lah slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2014</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Employing humble everyday materials like sponges and tape, Long Beach artist Olga Lah transforms architectural spaces into texturally complex environments. Her 2011 work Array consists of thousands of colored sponges that have been stacked into comically leaning rows and wobbly walls, while in For the Land (made the same year) she used only paper of varying shades of blue and gray to envelop a door and passageway, converting the space into baroque fantasy. The jury was particularly impressed with the 2013 installation,Moving the Line,in which Lah positioned colored vinyl tape to literally draw in space, describing an inverted pyramid along the side of a room through a series of off-kilter colored lines that together possess an imposing sculptural presence, despite being visibly immaterial.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Alma Ruiz, Senior Curator, MOCA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Carol Eliel, Curator of Modern Art, LACMA</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Dan Cameron, Chief Curator, Orange County Museum of Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Olga Lah is a second generation Korean-American, born and raised in the Los Angeles area. She now resides in Long Beach, California. She received a B.A. in both Studio Art and Art History from the University of California at Riverside. She also received an M.A. in Theology from Fuller Theological Seminary. Her interest in the relationship between theology and art led her to an art practice exploring these themes in site-specific installations and sculpture. She has exhibited most recently at the Craft and Folk Art Museum, Los Angeles; the Torrance Art Museum, Torrance; and at the Venice Arsenale in Italy. She is the First Place award winner of the Art of Now International Competition juried by Senior Curator Emeritus of the Riverside Art Museum. She has been awarded residencies at the prestigious Djerassi Resident Artists Program in Woodside, CA.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Employing humble everyday materials like sponges and tape, Long Beach artist Olga Lah transforms architectural spaces into texturally complex environments. Her 2011 work Array consists of thousands of colored sponges that have been stacked into comically leaning rows and wobbly walls, while in For the Land (made the same year) she used only paper of varying shades of blue and gray to envelop a door and passageway, converting the space into a baroque fantasy. The jury was particularly impressed with the 2013 installation Moving the Line, in which Lah positioned colored vinyl tape to literally draw in space, describing an inverted pyramid along the side of a room through a series of off-kilter colored lines that together possess an imposing sculptural presence, despite being visibly immaterial.</p>

            <a href='https://www.olgalah.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
